/*
 * Judge.me carousel heading — purple count run.
 *
 * The drawn heading sets "100.000+" in brand purple inside an otherwise black
 * line, but the widget hands over the whole title as a single plain text node
 * from its own app setting. CSS cannot colour part of a text node, so the count
 * is wrapped in a span here and coloured in standalone-judgeme-carousel.css.
 *
 * The widget rewrites the heading once its slider boots, which would drop the
 * span, so the wrap is re-applied on mutation instead of only on load. The
 * observer stops as soon as the wrap sticks, and gives up after a short window
 * so it never lives for the whole session.
 */
(function () {
  var CLASS = 'jdgm-carousel-title__num';
  /* First run of digits, allowing the file's "100.000+" grouping and a trailing
     plus, so the highlight follows the copy if the number is ever edited. */
  var COUNT = /\d[\d.,]*\+?/;
  var GIVE_UP_AFTER = 15000;

  function wrapTitle(title) {
    if (title.querySelector('.' + CLASS)) return true;

    var walker = document.createTreeWalker(title, NodeFilter.SHOW_TEXT, null, false);
    var node;

    while ((node = walker.nextNode())) {
      var match = COUNT.exec(node.nodeValue);
      if (!match) continue;

      // Split the text node so only the count ends up inside the span and the
      // surrounding words stay as they were.
      var count = node.splitText(match.index);
      count.splitText(match[0].length);

      var span = document.createElement('span');
      span.className = CLASS;
      span.appendChild(document.createTextNode(count.nodeValue));
      count.parentNode.replaceChild(span, count);
      return true;
    }

    return false;
  }

  function run() {
    var titles = document.querySelectorAll('.jdgm-carousel-title');
    var wrapped = false;

    for (var i = 0; i < titles.length; i++) {
      if (wrapTitle(titles[i])) wrapped = true;
    }

    return wrapped;
  }

  function start() {
    var host = document.querySelector('.jdgm-carousel-wrapper') || document.body;
    if (run() || typeof MutationObserver !== 'function') return;

    var observer = new MutationObserver(function () {
      // Re-entrant by design: disconnect around our own edit so the span we add
      // does not trip the observer that added it.
      observer.disconnect();
      var done = run();
      if (!done) observer.observe(host, OPTIONS);
    });

    var OPTIONS = { childList: true, subtree: true, characterData: true };
    observer.observe(host, OPTIONS);
    setTimeout(function () {
      observer.disconnect();
    }, GIVE_UP_AFTER);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
